import types, {
  CLEAR_CLIENT_BY_SEARCH,
} from "../../actions/clientsActions/types";
import { FETCH_STATUS } from "../../../constants";

export const clientSearch = (
  state = {
    data: {},
    status: FETCH_STATUS.NOT_LOADED,
    error: "",
  },
  action
) => {
  const { payload: { data, error } = {} } = action;
  switch (action.type) {
    case types.FETCH_CLIENT_BY_SEARCH_REQUEST:
      return {
        ...state,
        status: FETCH_STATUS.LOADING,
        error: null,
      };
    case types.FETCH_CLIENT_BY_SEARCH_SUCCESS:
      return {
        ...state,
        data: data,
        status: FETCH_STATUS.LOADED,
      };
    case types.FETCH_CLIENT_BY_SEARCH_FAILURE:
      return {
        ...state,
        status: FETCH_STATUS.FAILED,
        error,
      };
    case CLEAR_CLIENT_BY_SEARCH:
      return {
        data: {},
        status: FETCH_STATUS.NOT_LOADED,
      };
    default:
      return state;
  }
};
